export const ContractRatesValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.ContractRate.trim()) {
      errors.ContractRate = 'Contract Rate is required';
    } 
    if (!formData.ContractRateAmount.trim()) {
        errors.ContractRateAmount = 'Amount is required';
    }
    
  
    return errors;
  };
  
 